import axios from 'axios';
import toast from 'react-hot-toast';

const api = axios.create({
  baseURL: '/api',
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('qfl_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

let offlineToastId = null;

// Retry logic pour erreurs réseau et 5xx
const retryRequest = async (error, retryCount = 0) => {
  const MAX_RETRIES = 3;
  const RETRY_DELAY = 1000 * (retryCount + 1); // Exponential backoff

  // Retry seulement pour: timeouts, 5xx, erreurs réseau
  const shouldRetry =
    retryCount < MAX_RETRIES &&
    (error.code === 'ECONNABORTED' ||
      error.response?.status >= 500 ||
      (!error.response && error.message === 'Network Error'));

  if (shouldRetry) {
    await new Promise(resolve => setTimeout(resolve, RETRY_DELAY));
    return axios.request(error.config).catch(err => retryRequest(err, retryCount + 1));
  }

  return Promise.reject(error);
};

api.interceptors.response.use(
  (response) => {
    // Serveur de nouveau disponible — retirer le toast offline si présent
    if (offlineToastId) { toast.dismiss(offlineToastId); offlineToastId = null; }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('qfl_token');
      localStorage.removeItem('qfl_user');
      if (window.location.pathname !== '/login') window.location.href = '/login';
      return Promise.reject(error);
    }

    // Retry sur erreurs réseau et 5xx
    if (!error.response || error.response?.status >= 500 || error.code === 'ECONNABORTED') {
      return retryRequest(error);
    }

    // Serveur inaccessible (réseau coupé ou backend offline)
    if (!error.response && !offlineToastId) {
      offlineToastId = toast.error('Serveur inaccessible. Vérifiez votre connexion.', {
        duration: Infinity,
        id: 'offline-error',
      });
    }

    return Promise.reject(error);
  }
);

export default api;
